var render = function render(){var _vm=this,_c=_vm._self._c;return _c('w-alert',{staticClass:"margin-top-30 margin-bottom-30",attrs:{"closable":false,"level":"warning","message":_vm.l.t('lr.onvego-once-setup-is-complete', 'Once setup is complete, you will get calls from +1 (810) 627-7327. Add this number to your Phone.com and mobile device address books. Do not block this number.')}})
}
var staticRenderFns = []

export { render, staticRenderFns }